import { apiConfig } from "./apiConfig";

const getFileUnderPostsUrl = apiConfig.oftheday.tags.slug;
const getFileUnderRecentUrl = apiConfig.oftheday.tags.recent;

export const getFileUnderPosts = (axios, slug, page) => axios.get(`${getFileUnderPostsUrl}${slug}?page=${page}`);
export const getFileUndersRecentPopular = (axios) => axios.get(`${getFileUnderRecentUrl}`);
